import { useState } from "react";
import "../App.css";
import CustomerRoleHelp from "./CustomerRoleHelp";
import { CUSTOMER_ROLE_IDS } from "../customerRoles";

const DEFAULT_ROLE_OPTIONS = CUSTOMER_ROLE_IDS;

export default function AddUserModal({
  open,
  customerId,
  roleOptions = DEFAULT_ROLE_OPTIONS,
  onClose,
  onCreateNew,
}) {
  const [newUser, setNewUser] = useState({
    username: "",
    name: "",
    email: "",
    roles: [],
  });

  if (!open) return null;

  function handleSubmit() {
    if (!newUser.username || !newUser.name || !newUser.email) {
      alert("Username, name, and email are required");
      return;
    }
    onCreateNew(newUser);
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal"
        style={{ width: 560 }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Add User</h2>
        <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
          Customer ID: <code>{customerId}</code>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>Username / User ID</label>
          <input
            style={{ width: "100%" }}
            placeholder="e.g. jsmith"
            value={newUser.username}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, username: e.target.value }))
            }
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>Name</label>
          <input
            style={{ width: "100%" }}
            placeholder="Full name"
            value={newUser.name}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, name: e.target.value }))
            }
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>Email</label>
          <input
            style={{ width: "100%" }}
            placeholder="user@company.com"
            value={newUser.email}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, email: e.target.value }))
            }
          />
        </div>

        <RoleSelector
          title="Assign Roles (for this customer)"
          roles={newUser.roles}
          roleOptions={roleOptions}
          onChange={(roles) => setNewUser((p) => ({ ...p, roles }))}
        />

        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 8 }}>
          User will be created in Cognito and linked to this customer. An invite
          email is sent if Cognito email is configured.
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 24,
          }}
        >
          <button onClick={onClose}>Cancel</button>
          <button
            onClick={handleSubmit}
            style={{ background: "#2563eb", color: "white" }}
          >
            Create & Add User
          </button>
        </div>
      </div>
    </div>
  );
}

function RoleSelector({ title, roles, roleOptions, onChange }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 6,
        }}
      >
        <div style={{ fontWeight: 600 }}>{title}</div>
        <CustomerRoleHelp />
      </div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        {roleOptions.map((role) => (
          <label key={role} style={{ fontSize: 13 }}>
            <input
              type="checkbox"
              checked={roles.includes(role)}
              onChange={() => onChange(toggle(roles, role))}
            />{" "}
            {role}
          </label>
        ))}
      </div>
    </div>
  );
}

function toggle(list, value) {
  return list.includes(value)
    ? list.filter((v) => v !== value)
    : [...list, value];
}
